<template>
  <div class="page-fixed-footer" :class="{collapse: sidebar}">
    <slot>
      <BaseElButton
        v-if="!hideCancel"
        class="btn"
        testName="pageFooter_cancel"
        plain
        @click="$emit('cancel')"
      >
        {{ cancelBtn || $t('common.button.cancel.text') }}
      </BaseElButton>
      <BaseElButton
        v-loading="confirmLoading"
        testName="pageFooter_confirm"
        :disabled="disabledConfirm"
        class="btn"
        type="primary"
        @click="$emit('confirm')"
      >
        {{ confirmBtn || $t('common.button.confirm.text') }}
      </BaseElButton>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'PageFixedFooter',
  props: {
    disabledConfirm: { type: Boolean, default: false },
    disabledCancel: { type: Boolean, default: false },
    hideCancel: { type: Boolean, default: false },
    confirmLoading: { type: Boolean, default: false },
    cancelBtn: { type: String },
    confirmBtn: { type: String },
  },
  computed: {
    sidebar () {
      return this.$store.getters.sidebar
    },

    isMobile () {
      return this.$store.state.app.isMobile
    },
  },
}
</script>

<style lang="postcss" scoped>
.page-fixed-footer {
  @apply absolute bottom-0 bg-white left-0 right-0 z-[5];
  @apply flex justify-end py-[20px] px-[40px] rounded-tr-sm rounded-tl-sm;
  box-shadow: 0px -2px 6px rgba(95, 95, 95, 0.1);
  transition: ease-in-out .3s;
}

.btn {
  @apply min-w-[100px];
}

.collapse {
  @apply left-[260px];
}
</style>
